var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { fixedForwardRef } from "../../../common/LibComponentProps";
import { Link } from "../Link";
var UnwrappedFooterV2BottomLink = function (props, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
ref) {
    var children = props.children, className = props.className, style = props.style, otherProps = __rest(props, ["children", "className", "style"]);
    var classFooterBottomLink = "fr-footer__bottom-link";
    if (className) {
        classFooterBottomLink += " ".concat(className);
    }
    return (React.createElement("li", { className: "fr-footer__bottom-item", style: style },
        React.createElement(Link, __assign({}, otherProps, { className: classFooterBottomLink, ref: ref }), children)));
};
var FooterV2BottomLink = fixedForwardRef(UnwrappedFooterV2BottomLink);
export default FooterV2BottomLink;
